
import axios from 'axios'
import queryStringUtil from "query-string";

function queryString(query) {
    var queryParams = {
        page: query.page,
        pageSize: query.pageSize,
    };
    return queryStringUtil.stringify(queryParams, {
        arrayFormat: "bracket"
    });
}


function getGateways(query) {
    return axios.get(`${process.env.VUE_APP_APIURL}/gateway?${queryString(query)}`)
        .then(resp => {
            return {
                total: resp.data.total,
                gateways: resp.data.gateways.map(x => {
                    return {
                        ...x,
                        status: {}
                    }
                })
            }
        })
}

function updateConfig(id, config) {
    return axios.put(`${process.env.VUE_APP_APIURL}/gateway/${id}/config`, config)
        .then(resp => {
            return resp.data
        })
}
export default {
    getGateways,
    updateConfig
};